import { Link } from 'react-router-dom';

import Logo from '../../_content/images/main/logos/innovate_uk_logo.png';
// import useDarkMode from 'lib/src/hooks/useDarkMode';
// import ToggleSwitch from '@components/form/ToggleSwitch';

const Header: React.FC = () => {
    // const [darkMode, setDarkMode] = useDarkMode();

    return (
        <header className="header">
            <div className="logo">
                <Link to="/" className="logo">
                    <img alt="company logo" src={Logo} />
                    {/* <span className="bordered-line" />
                    <p>
                        Innovation<br></br>Exchange
                    </p> */}
                </Link>
            </div>
            {/* <div className="dark-mode-switch">
                <ToggleSwitch
                    label="Dark mode"
                    name="darkmode"
                    onChange={() => setDarkMode(!darkMode)}
                    value={darkMode}
                    textColour="white"
                />
            </div> */}
        </header>
    );
};

export default Header;
